(function (w, factory) {
    w.PublicEStore = factory();
}(window, function () {
    var $ = window.jQuery;
    var _ = window._;
    var globalActionChannel = 'estore.action';
    var globalCallbackChannel = 'estore.callback';
    var globalErrorChannel = 'estore.error';

    var handlerUrl = window.R + 'Handlers/Public/PublicEStore.ashx';

    var internalCache = {};

    var publicEStore = {
        name: 'MPEF'
    };

    // Check if PubSub engine was loaded
    var pubSub = window.PubSub;
    if(typeof pubSub !== 'object' || !pubSub) {
        console.error('PubSub library is not loaded');
        return null;
    }

    // Supported action values should always be in lower case!
    var supportedActions = {
        addToCart: 'addtocart',
        removeFromCart: 'removefromcart',
        emptyCart: 'emptycart',
        updateCartQuantity: 'updatecartquantity',
        getCartInfo: 'getcartinfo',
        getDetailedCartInfo: 'getdetailedcartinfo',
        getTempOrderLines: 'gettemporderlines',
        getBuyFeedbackData: 'getbuyfeedbackdata',
        addToShoppingList: 'addtoshoppinglist',
        removeFromShoppingList: 'removefromshoppinglist',
        addToWishList: 'addtowishlist',
        removeFromWishList: 'removefromwishlist',
        getShoppingList: 'getshoppinglist',
        getShoppingLists: 'getshoppinglists',
        addShoppingList: 'addshoppinglist',
        updateShoppingList: 'updateshoppinglist',
        updateShoppingListItemsQuantity: 'updateshoppinglistitemsquantity',
        updateShoppingListItemsDescription: 'updateshoppinglistitemsdescription',
        removeShoppingList: 'removeshoppinglist',
        getShoppingListInfo: 'getshoppinglistinfo',
        getWishListInfo: 'getwishlistinfo',
        getEStoreContext: 'getestorecontext',
        getCustomerShoppingHistory: 'getcustomershoppinghistory',
        reorderShoppingListItems: 'reordershoppinglistitems',
        addToOfferRequest: 'addtoofferrequest',
        getofferrequestsinfo: 'getofferrequestsinfo',
        removefromcartofferrequest: 'removefromcartofferrequest',
        emptyofferrequests: 'emptyofferrequests'
    };

    var supportedChannels = {
        action: {
            global: globalActionChannel,
            shopCart: globalActionChannel + '.shopcart',
            shoppingList: globalActionChannel + '.shoppinglist',
            offerRequest: globalActionChannel + '.offerrequest'
        },
        callback: {
            global: globalCallbackChannel,
            shopCart: globalCallbackChannel + '.shopcart',
            shoppingList: globalCallbackChannel + '.shoppinglist',
            offerRequest: globalCallbackChannel + '.offerrequest'
        },
        error: {
            global: globalErrorChannel
        }
    };

    var actionHandler = function (topic, requestObj, deferred, isPrivate) {
        if (typeof requestObj === 'object' && requestObj) {
            var privateAction = !!isPrivate;
            var contract = _.omit(requestObj, ['callerId', 'transactionId', 'action', 'includeVat']);
            var errorTopic = requestObj.callerId ? globalErrorChannel + '.' + requestObj.callerId : globalErrorChannel;
            $.ajax({
                url: handlerUrl,
                type: 'POST',
                data: {
                    callerId: requestObj.callerId,
                    transactionId: requestObj.transactionId ? requestObj.transactionId : new Date().getTime(),
                    action: requestObj.action,
                    contract: JSON.stringify(contract),
                    includeVat: requestObj.includeVat
                },
                dataType: 'json',
                success: function (response) {
                    switch (response.status.toLowerCase()) {
                        case 'ok':
                        case 'warning':
                            // Publish message only for the public actions
                            if (!privateAction) {
                                var pubTopic = topic.replace(globalActionChannel, globalCallbackChannel) + '.' + response.action;
                                pubSub.publish(pubTopic, response);
                            }
                            // Call custom callback if specified
                            if (typeof deferred === 'object' && deferred) {
                                deferred.resolve(response);
                            }
                            break;
                        default:
                            // Publish message only for the public actions
                            if (!privateAction) {
                                pubSub.publish(errorTopic, response);
                            }
                            // Call custom error callback if specified
                            if (typeof deferred === 'object' && deferred) {
                                deferred.reject(response);
                            }
                            break;
                    }
                },
                error: function (jqXHR, errorStatus, errorThrown) {
                    // Since all internal server errors are handled by the backend, this handler will be executed very rare,
                    // mostly in cases when application is unavailable or there are some network issues
                    var error = {
                        action: requestObj.action,
                        transactionID: requestObj.transactionId,
                        status: 'Error',
                        message: errorThrown
                    };

                    if (!privateAction) {
                        pubSub.publish(errorTopic, error);
                    }

                    // Call custom error callback if specified
                    if (typeof deferred === 'object' && deferred) {
                        deferred.reject(error);
                    }
                }
            });
        }
    };

    var getRequiredFieldName = function (action) {
        // Determine required field name according to the action
        var targetContractField = 'productId';
        switch (action.toLowerCase()) {
            case supportedActions.removeFromCart:
            case supportedActions.getBuyFeedbackData:
                targetContractField = 'tempOrderLineId';
                break;
            case supportedActions.addToShoppingList:
            case supportedActions.removeFromShoppingList:
            case supportedActions.addToWishList:
            case supportedActions.removeFromWishList:
                targetContractField = 'productId';
                break;
        }

        return targetContractField;
    };

    var getActionChannel = function (action) {
        if (typeof action !== 'string' || !action) {
            return '';
        }

        var channel = globalActionChannel;
        switch (action.toLowerCase()) {
            case supportedActions.addToCart:
            case supportedActions.removeFromCart:
            case supportedActions.emptyCart:
            case supportedActions.updateCartQuantity:
            case supportedActions.getCartInfo:
            case supportedActions.getDetailedCartInfo:
            case supportedActions.getTempOrderLines:
            case supportedActions.getBuyFeedbackData:
                channel = supportedChannels.action.shopCart;
                break;
            case supportedActions.addToShoppingList:
            case supportedActions.removeFromShoppingList:
            case supportedActions.addToWishList:
            case supportedActions.removeFromWishList:
            case supportedActions.getShoppingList:
            case supportedActions.getShoppingLists:
            case supportedActions.addShoppingList:
            case supportedActions.updateShoppingList:
            case supportedActions.updateShoppingListItemsQuantity:
            case supportedActions.updateShoppingListItemsDescription:
            case supportedActions.removeShoppingList:
            case supportedActions.getShoppingListInfo:
            case supportedActions.getWishListInfo:
            case supportedActions.reorderShoppingListItems:
                channel = supportedChannels.action.shoppingList;
                break;
            case supportedActions.addToOfferRequest:
            case supportedActions.getofferrequestsinfo:
            case supportedActions.removefromcartofferrequest:
            case supportedActions.emptyofferrequests:
                channel = supportedChannels.action.offerRequest;
                break;
        }

        return channel;
    };

    var preProcessItems = function (items, requiredField) {
        if (!items) {
            return [];
        }

        var prods = $.isArray(items) ? items : [items];
        // Some actions does not require the whole contract to be specified into the request
        // In this case, assume that if 'items' field is not an array of objects, then it is an array of a single required for the action fields
        if (prods.length > 0 && typeof prods[0] !== 'object' && typeof requiredField !== 'undefined') {
            // Create item objects based on the passed required field values
            prods = $.map(prods, function (value) {
                var itemObj = {};
                itemObj[requiredField] = value;
                return itemObj;
            });
        }

        // Fix comma float number separator. On the server side InvariantCulture is using while parsing JSON, so we need to replace ',' with '.' for floats
        _.each(prods, function (prod) {
            if (prod.quantity && prod.quantity.replace) {
                prod.quantity = prod.quantity.replace(',', '.');
            }
        });

        return prods;
    };

    var getPromise = function (requestObj, isPrivate) {
        return $.Deferred(function (defer) {
            actionHandler(getActionChannel(requestObj.action), requestObj, defer, isPrivate);
        }).promise();
    };

    publicEStore.actions = supportedActions;

    publicEStore.channels = supportedChannels;

    publicEStore.publish = function (channel, data) {
        return pubSub.publish(channel, data);
    };

    publicEStore.subscribe = function (channel, handler) {
        return pubSub.subscribe(channel, handler);
    };

    publicEStore.unsubscribe = function (tokenOrFunction) {
        return pubSub.unsubscribe(tokenOrFunction);
    };

    publicEStore.addToCart = function (items, includeVat, isPrivate) {
        var action = supportedActions.addToCart;
        var requestObj = { action: action, items: preProcessItems(items), includeVat: includeVat };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.removeFromCart = function (items, isPrivate) {
        var action = supportedActions.removeFromCart;
        var requestObj = { action: action, items: preProcessItems(items, getRequiredFieldName(action)) };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.emptyCart = function(isPrivate) {
        var action = supportedActions.emptyCart;
        var requestObj = { action: action };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.updateCartQuantity = function (items, isPrivate) {
        var action = supportedActions.updateCartQuantity;
        var requestObj = { action: action, items: preProcessItems(items) };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.addToShoppingList = function (shoppingListId, items, includeVat, isPrivate) {
        var action = supportedActions.addToShoppingList;
        var requestObj = { action: action, items: preProcessItems(items, getRequiredFieldName(action)), shoppingListId: shoppingListId, includeVat: includeVat };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.removeFromShoppingList = function (shoppingListId, items, isPrivate) {
        var action = supportedActions.removeFromShoppingList;
        var requestObj = { action: action, items: preProcessItems(items, getRequiredFieldName(action)), shoppingListId: shoppingListId };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.addShoppingList = function(name, description, items, includeVat, isPrivate) {
        var action = supportedActions.addShoppingList;
        var requestObj = { action: action, name: name, description: description, items: preProcessItems(items, getRequiredFieldName(action)), includeVat: includeVat };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.updateShoppingList = function (shoppingListId, name, description, isPrivate) {
        var action = supportedActions.updateShoppingList;
        var requestObj = { action: action, shoppingListId: shoppingListId, name: name, description: description };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.updateShoppingListItemsQuantity = function (items, isPrivate) {
        var action = supportedActions.updateShoppingListItemsQuantity;
        var requestObj = { action: action, items: preProcessItems(items) };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.updateShoppingListItemsDescription = function (items, isPrivate) {
        var action = supportedActions.updateShoppingListItemsDescription;
        var requestObj = { action: action, items: preProcessItems(items) };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.removeShoppingList = function (shoppingListId, isPrivate) {
        var action = supportedActions.removeShoppingList;
        var requestObj = { action: action, shoppingListId: shoppingListId };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.getShoppingLists = function(isPrivate) {
        var action = supportedActions.getShoppingLists;
        var requestObj = { action: action };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.addToWishList = function (items, includeVat, isPrivate) {
        var action = supportedActions.addToWishList;
        var requestObj = { action: action, items: preProcessItems(items, getRequiredFieldName(action)), includeVat: includeVat };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.removeFromWishList = function (items, isPrivate) {
        var action = supportedActions.removeFromWishList;
        var requestObj = { action: action, items: preProcessItems(items, getRequiredFieldName(action)) };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.getTempOrderLines = function (includeVat, isPrivate) {
        var action = supportedActions.getTempOrderLines;
        var requestObj = { action: action, includeVat: includeVat };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.getCartInfo = function (includeVat, isPrivate) {
        var action = supportedActions.getCartInfo;
        var requestObj = { action: action, includeVat: includeVat };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.getDetailedCartInfo = function(includeVat, isPrivate, imageWidth, imageMod) {
        var action = supportedActions.getDetailedCartInfo;
        var requestObj = { action: action, includeVat: includeVat, imageWidth: imageWidth, imageMod: imageMod };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.getShoppingList = function (shoppingListId, includeVat, isPrivate, itemsGroups, buyMode) {
        var action = supportedActions.getShoppingList;
        var requestObj = { action: action, shoppingListId: shoppingListId, includeVat: includeVat, itemsGroups: itemsGroups, buyMode: buyMode };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.getWishList = function (includeVat, isPrivate) {
        return publicEStore.getShoppingList(0, includeVat, isPrivate);
    };

    publicEStore.getShoppingListInfo = function (shoppingListId, includeVat, isPrivate) {
        var action = supportedActions.getShoppingListInfo;
        var requestObj = { action: action, shoppingListId: shoppingListId, includeVat: includeVat };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.getWishListInfo = function (includeVat, isPrivate) {
        var action = supportedActions.getWishListInfo;
        var requestObj = { action: action, includeVat: includeVat };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.getEStoreContext = function (forceGetFromServer, isPrivate) {
        if (!internalCache['estorecontext'] || forceGetFromServer) {
            var action = supportedActions.getEStoreContext;
            var requestObj = { action: action };

            internalCache['estorecontext'] = getPromise(requestObj, isPrivate);
        }

        return internalCache['estorecontext'];
    };

    publicEStore.getBuyFeedbackData = function (buyfeedbackItems, isPrivate) {
        var action = supportedActions.getBuyFeedbackData;
        var requestObj = { action: action, items: preProcessItems(buyfeedbackItems, getRequiredFieldName(action)) };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.getCustomerShoppingHistory = function() {
        var action = supportedActions.getCustomerShoppingHistory;
        var requestObj = { action: action };

        return getPromise(requestObj);
    };

    publicEStore.reorderShoppingListItems = function (items, moveTo, isPrivate) {
        var action = supportedActions.reorderShoppingListItems;
        var requestObj = { action: action, items: preProcessItems(items), moveTo: moveTo };

        return getPromise(requestObj, isPrivate);
    };

    publicEStore.addToOfferRequest = function (items) {
        var action = supportedActions.addToOfferRequest;
        var requestObj = { action: action, items: preProcessItems(items) };

        return getPromise(requestObj);
    };

    publicEStore.getofferrequestsinfo = function () {
        var action = supportedActions.getofferrequestsinfo;
        var requestObj = { action: action };

        return getPromise(requestObj);
    };

    publicEStore.removefromcartofferrequest = function (items) {
        var action = supportedActions.removefromcartofferrequest;
        var requestObj = { action: action, items: preProcessItems(items) };

        return getPromise(requestObj);
    };

    publicEStore.emptyofferrequests = function (isPrivate) {
        var action = supportedActions.emptyofferrequests;
        var requestObj = { action: action };

        return getPromise(requestObj, isPrivate);
    };
    

    // Subscribe to the action channels
    var internalSubcriptionToken = pubSub.subscribe(globalActionChannel, actionHandler);

    publicEStore.destroy = function () {
        pubSub.unsubscribe(internalSubcriptionToken);
        internalCache = null;
    };

    return publicEStore;
}));